import React from "react";
import classNames from "classnames";
import style from "./style.scss";

export const RiskMeter = ({ level, percent }) => {
    return (
        <div
            className={classNames(style.base, {
                [style.low]: level === "low",
                [style.mid]: level === "mid",
                [style.high]: level === "high"
            })}
        >
            <div
                className={classNames(style.dot, {
                    [style.isOn]: percent > 0
                })}
            ></div>
            <div
                className={classNames(style.dot, {
                    [style.isOn]: percent > (1 / 3) * 100
                })}
            ></div>
            <div
                className={classNames(style.dot, {
                    [style.isOn]: percent > (2 / 3) * 100
                })}
            ></div>
        </div>
    );
};
